import { render, staticRenderFns } from "./ProfitReport.vue?vue&type=template&id=4cb6a948&scoped=true"
import script from "./ProfitReport.vue?vue&type=script&lang=js"
export * from "./ProfitReport.vue?vue&type=script&lang=js"
import style0 from "./ProfitReport.vue?vue&type=style&index=0&id=4cb6a948&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cb6a948",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JSH_ERP\\JSH_ERP\\mgerpweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4cb6a948')) {
      api.createRecord('4cb6a948', component.options)
    } else {
      api.reload('4cb6a948', component.options)
    }
    module.hot.accept("./ProfitReport.vue?vue&type=template&id=4cb6a948&scoped=true", function () {
      api.rerender('4cb6a948', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/plugin/profit-report/ProfitReport.vue"
export default component.exports